module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Secretly Smitten")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0097-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page97"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter3"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "NE",
      "id": "p0097-d6e12",
      "src": "images/9781401687137_I_0097_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0097-03-1"
    }
  }, [_c('span', {
    staticClass: "dcap2"
  }, [_vm._v("Z")]), _vm._v("oe Thomas perched herself atop the metal ladder and straightened the wooden sign that read "), _c('i', [_vm._v("Cupid’s ")]), _c('i', [_vm._v("Arrow Matchmaking Services")]), _vm._v(". She looked down at her older sister, who stood on Main Street’s brick walkway. “Better?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0097-04-4"
    }
  }, [_vm._v("“A little higher on the right,” Clare called up. Zoe wondered if it would ever be straight according to Clare’s exacting standards.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0097-04-5"
    }
  }, [_vm._v("She pressed upward and peered down again to the brick sidewalk. “Now?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0097-04-6"
    }
  }, [_vm._v("“Perfect,” Clare confirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0097-04-7"
    }
  }, [_vm._v("Zoe breathed a sigh of relief, amazed that Clare hadn’t produced a level from the overalls she wore. Clare could survive in the woods for an eternity with all that came out of those gardener pockets of hers. Zoe jumped from the ladder and brushed her hands together. Seeing the hand-painted calligraphy announcing her business made everything so real.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0097-04-8"
    }
  }, [_vm._v("“Can’t you just feel the love? Imagine Smitten being bitten by its own love bug. And Nat’s marriage to Carson was the perfect kickoff to my new business.” Zoe’s heart filled with possibilities, seeing the fruits of her labor. The tired storefront looked fresh and inviting with its newly painted wood-paned windows and a gold-framed “services offered” announcement. She’d draped two small crystal chandeliers "), _c('a', {
    attrs: {
      "id": "page98"
    }
  }, [_vm._v("in jewel tones to bring attention to the services menu, and with a little specialized lighting, the display would emanate romance.")])]), _c('a', {
    attrs: {
      "id": "page98"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0098-02-2"
    }
  }, [_vm._v("Clare grimaced. “This is still Smitten. If the men here have been bitten by anything, it’s something closer to a mosquito carrying malaria.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0098-02-3"
    }
  }, [_vm._v("Zoe’s shoulders slumped. Poor Clare, never looking for the spontaneous. “Life is too short to be so serious, Clare. We can’t exactly claim to be the romance capital if we don’t believe our own slogan. Romance should start here; we shouldn’t simply import it.” She blew her bangs off her glistening forehead. “It’s hot already today. I’m glad we started so early.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0098-02-4"
    }
  }, [_vm._v("Clare wouldn’t allow her to change the subject. “The point is, Smitten is a romantic "), _c('i', [_vm._v("destination")]), _vm._v(". The couples bring the love with them. We just warm the embers of the fire they’ve already built. I’m worried, Zoe. You could lose everything with this.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0098-02-5"
    }
  }, [_vm._v("“We have plenty of single men and women in Smitten. Why shouldn’t we start a spark of our own? Remember that song we sang at church camp?” She struck a pose and started to sing. “It only takes a spark to get a fire going . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0098-02-7"
    }
  }, [_vm._v("“Fire, and a bit of dynamite might get things going.” Clare’s ponytail bobbed as she spoke, which was a lot of passion coming from her serious older sister.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0098-02-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page98"
    }
  }, [_vm._v("“Now you’re just being surly.” Zoe knew Clare’s words came from a deep need for security. In Clare’s mind, one didn’t just willy-nilly up and decide to start a business. It took expertise like Clare possessed in gardening, and then accountants with ten-year forecasts for the math skills the ")]), _c('a', {
    attrs: {
      "id": "page99"
    }
  }, [_vm._v("sisters hadn’t mastered. “If I lose everything, I’ll let you be the first to say ‘I told you so.’ How’s that?”")])]), _c('a', {
    attrs: {
      "id": "page99"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0099-02-2"
    }
  }, [_vm._v("“I’m only saying”—Clare spoke in her soft, motherly tone—“I’d be remiss if I didn’t say that I’m worried about you. You’ve worked so hard for what little you have. Why not forget all this and go to college? Smitten will be here when you get back.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0099-02-3"
    }
  }, [_vm._v("Zoe waited out the recycled warning. Advice that had already come from her cousin Natalie, from her mother, and from most everyone in town whom she’d ever been straight with in her long history of not being able to keep her opinion to herself. People had a nasty way of enjoying telling her their predictions of imminent failure, which only made her want to succeed more. Not to prove them wrong, but because she believed so strongly in what she was doing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0099-02-4"
    }
  }, [_vm._v("“Not everyone has a big family like we do, Clare. People are lonely. I see it every day when I deliver dinner to the shut-ins. Human contact is what makes life worth living. If I can make that happen for one person, it will be worth it. Okay, I guess it would be two people . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0099-02-6"
    }
  }, [_vm._v("Clare rubbed her head as if the conversation gave her a migraine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0099-02-7"
    }
  }, [_vm._v("“Smitten needs a matchmaker. Dating in a small town is never a secret, so folks keep to themselves rather than risk public humiliation on a relationship that might fail. This way it’s my failure, and no one is the wiser. Do you see?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0099-02-8"
    }
  }, [_vm._v("“Not really, but somehow the Lord always looks out for you. I’m going to pray he works extra hard this time.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0099-02-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page99"
    }
  }, [_vm._v("“We have different ideas of success, Clare. If all it takes for people to be less lonely is a little initiative on my part, ")]), _c('a', {
    attrs: {
      "id": "page100"
    }
  }, [_vm._v("that’s worth my time and money. Don’t you think? The failure is in ignoring my calling.”")])]), _c('a', {
    attrs: {
      "id": "page100"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0100-02-2"
    }
  }, [_vm._v("“Everyone in town already knows each other,” Clare protested.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0100-02-3"
    }
  }, [_vm._v("“That’s true, but with the neighboring towns, the seasonal employees, and even with the locals, they need encouragement. They need a chance to get to know one another without the pressure of everyone knowing their business. Maybe they think love is not in the cards for them, but it’s actually right in front of them if they’ll only take this small risk.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0100-02-4"
    }
  }, [_vm._v("“And pay the small membership fee.” Clare shook her head. “Zoe, I love how you care for people. I really do. I’m only worried there’s no money in this as a business. Your heart is so huge that you never think of details like cash flow. Trust me, it matters.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0100-02-6"
    }
  }, [_vm._v("Clare ran a seasonal plant nursery, and she worried each winter that this was the year she wouldn’t make it to spring.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0100-02-7"
    }
  }, [_vm._v("“I know you’re good at discerning people who might belong together, but does that mean there’s a business in it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0100-02-8"
    }
  }, [_vm._v("“Maybe they won’t pay,” Zoe said. “I’ll make you a deal. If I haven’t turned a profit within the year, I’ll apply for college next fall.” She regretted her words the minute they tumbled out of her mouth, but it only meant Cupid’s Arrow had to work.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0100-02-9"
    }
  }, [_vm._v("Clare exhaled audibly. “All right, Zoe. I don’t understand it. I never have understood that romantic view of life you’ve got, but if this is what you want, I’ve got no choice but to support you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0100-02-10"
    }
  }, [_vm._v("Zoe had heard that her whole life, about her romantic dreams and magical, dreamy way of thinking.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0101-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page100"
    }
  }), _c('a', {
    attrs: {
      "id": "page101"
    }
  }, [_c('i', [_vm._v("“Why")]), _vm._v(" "), _c('i', [_vm._v("didn’t you go to college, Zoe?”")])])]), _c('a', {
    attrs: {
      "id": "page101"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0101-01-1"
    }
  }, [_c('i', [_vm._v("“Smartest")]), _vm._v(" "), _c('i', [_vm._v("girl")]), _vm._v(" "), _c('i', [_vm._v("in")]), _vm._v(" "), _c('i', [_vm._v("town, but you’ve got no ambition.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0101-01-2"
    }
  }, [_c('i', [_vm._v("“There’s an entire world outside of Smitten if you’d only go search it out")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0101-01-3"
    }
  }, [_vm._v("But she wasn’t as starry-eyed as everyone thought. She simply had no interest in a world bigger than Smitten. She had everything she needed right here: good friends, people she loved and cared about deeply, a ministry with the town’s senior citizens. Now that she’d started her own business, her family should finally feel the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0101-01-4"
    }
  }, [_vm._v("The screech of metal punctuated by an awkward "), _c('i', [_vm._v("clank")]), _vm._v(" seized their attention. Zoe rushed to the wobbly ladder and caught it right before it hit her storefront window. She braced the ladder against the clapboard wall and pressed her back against it to hold everything steady, but a spray of nails rained down around her. She glared at the stranger who had mistakenly walked into the obstacle, and tried to make sense of what just happened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0101-01-5"
    }
  }, [_vm._v("The first thing she noticed was his eyes. They were a color she’d never seen before, a watery mix of gray, blue, and green—like a rare marble she might have fought over as a child. Against the man’s tan skin, their intensity was heightened. She searched for something rational to say but kept getting lost in his gaze, which was like a mystery she needed to solve.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0101-01-8"
    }
  }, [_vm._v("She finally snapped out of her dreamy state and realized that he was bleeding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0101-01-9"
    }
  }, [_vm._v("“I’ll call you back.” The man, dressed in a fancy dark city suit with a look-at-me sheen, pressed at his ear, and she assumed that he was disconnecting from some type of innerear Borg device. He took her hands into his own. “Are you all right? I didn’t hurt you, did I?”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0102-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page101"
    }
  }), _c('a', {
    attrs: {
      "id": "page102"
    }
  }, [_vm._v("He dropped one of her hands and touched her hair—a touch she felt to her toes. He showed her a long silver nail that he’d removed from her hair and smiled in a way that felt so intimate she clutched the collar of her T-shirt to protect herself.")])]), _c('a', {
    attrs: {
      "id": "page102"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0102-01-1"
    }
  }, [_vm._v("“You’ve got a small cut,” she managed. “C-come in the back and I’ll clean it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0102-01-2"
    }
  }, [_vm._v("He rubbed his right temple where he’d run into the ladder. She could see the red mark developing. Selfishly she worried she’d have her first lawsuit before she opened the doors for business, but she quelled the thought.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0102-01-3"
    }
  }, [_vm._v("The mystery man pulled a handkerchief from his suit jacket and dabbed the side of his head. “I’ll be fine. I’m not sure how I missed that ladder.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0102-01-4"
    }
  }, [_vm._v("She looked at the rusted ladder and pondered the same thing, but she didn’t want to say anything to incriminate herself further.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0102-01-5"
    }
  }, [_vm._v("“I’m not sure if you’re aware of it, but it’s against city policy to obstruct the sidewalk during business hours without a permit. Do you have a permit?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0102-01-6"
    }
  }, [_vm._v("“I . . . uh, what?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0102-01-7"
    }
  }, [_vm._v("“A permit. You can obtain them at city hall. Soon you’ll be able to download an application off the Internet, but you need to give me at least a month for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0102-01-8"
    }
  }, [_vm._v("“And who are you exactly?” She pressed herself farther back against the ladder in a pathetic attempt to hide it. “What I mean is, how would you know what’s illegal in Smitten? I’ve never seen you before.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0102-01-9"
    }
  }, [_vm._v("He raised a brow. “I’m the new city manager. It’s my job to know the city codes—and to see that they’re implemented.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page102"
    }
  }), _c('a', {
    attrs: {
      "id": "page103"
    }
  }, [_vm._v("Zoe shook her head in disbelief that a complete stranger was telling her about Smitten. “I’ve been in this town my whole life. We don’t have a city manager.” She looked to her sister for backup, but Clare just shrugged as if none of it concerned her.")])]), _c('a', {
    attrs: {
      "id": "page103"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0103-01-1"
    }
  }, [_vm._v("“The town board hired me. With all the recent successes after Sawyer Smitten’s wedding, this has become a real destination spot. That requires more management than your selectpersons can handle, I’m afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0103-01-2"
    }
  }, [_vm._v("“Yes, I’m afraid too.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0103-01-3"
    }
  }, [_vm._v("“You’ve heard we’ve been in contact with RailAmerica to get the railroad to come back to Smitten.” He felt his temple, then looked at the tips of his fingers, tinged by his own blood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0103-01-4"
    }
  }, [_vm._v("“Naturally.” Zoe loathed his know-it-all tone, as if she were some kind of weekender to be patted on the head and sent home with a bottle of maple syrup.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0103-01-5"
    }
  }, [_vm._v("“Dealing with the railroad will be one of my primary duties, but safety is priority one. A ladder on the sidewalk of Main Street in the middle of high season is a genuine hazard. I’m glad it was me who walked into it and not an elderly tourist. It’s going to take cash to get that railroad here, and a lawsuit is something we can’t afford.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0103-01-6"
    }
  }, [_vm._v("Zoe tried to see things from his perspective, but the way he acted, as if he cared more about Smitten than she did, made her want to tell him that elderly people paid attention to where they were going. When she didn’t answer, he kept talking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0103-01-7"
    }
  }, [_vm._v("“With these uneven bricks, a ladder on Main Street is not ideal in any season. This”—he gripped the ladder—“should be secured and surrounded by emergency cones.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0103-01-8"
    }
  }, [_vm._v("She stood at attention and saluted. “Aye aye, captain.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0104-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page103"
    }
  }), _c('a', {
    attrs: {
      "id": "page104"
    }
  }, [_vm._v("He looked away from her. “I didn’t mean to give orders.” His hurt expression, combined with the expanding puddle of blood on his temple, made the exchange feel surreal, as if someone else ruled her words—though she knew it was her own dark side afraid of change.")])]), _c('a', {
    attrs: {
      "id": "page104"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0104-01-1"
    }
  }, [_vm._v("“Come back into the store and I’ll clean that up for you.” Her fingertips aimed toward the small cut, but she clasped her fingers into a fist and veered at the last moment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0104-01-3"
    }
  }, [_vm._v("“I should have introduced myself first. I’m William Singer.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0104-01-4"
    }
  }, [_vm._v("“Can you? Sing, I mean. Our choir is always looking for baritones.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0104-01-5"
    }
  }, [_vm._v("“I can’t. Tone deaf as they come, so the name is, I suppose, unfortunate.” He pulled the ladder from behind her and fastened it shut. “Can I put this somewhere for you?” He paused. “I assume you’re done with it.” He looked up at the sign she’d just attached. “You did that yourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0104-01-6"
    }
  }, [_vm._v("She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0104-01-7"
    }
  }, [_vm._v("“It looks good. Straight.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0104-01-8"
    }
  }, [_vm._v("“Thanks to my sister Clare.” She nodded toward her sister, but William never removed his eyes from hers. He set the ladder against the wall again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0104-01-9"
    }
  }, [_vm._v("“Cupid’s Arrow.” He stepped back toward the street and crossed his arms over his chest. His jacket stretched and protested against his rounded biceps, and Zoe realized how out of place he looked in a suit. No one wore a suit in Smitten except on Sundays for church; during the week, it meant a funeral service. “A baby shop?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0104-01-10"
    }
  }, [_vm._v("“Aunt Violet told you it sounded like a baby shop,” Clare said.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page104"
    }
  }), _c('a', {
    attrs: {
      "id": "page105"
    }
  }, [_vm._v("It was as if they were children again, and Clare had added "), _c('i', [_vm._v("neener, neener, neener.")])])]), _c('a', {
    attrs: {
      "id": "page105"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0105-01-1"
    }
  }, [_vm._v("“It’s a "), _c('i', [_vm._v("matchmaking")]), _vm._v(" service.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0105-01-2"
    }
  }, [_vm._v("He blinked as though she spoke in a foreign tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0105-01-3"
    }
  }, [_vm._v("“People are so busy these days even in Smitten that they don’t make time for connection. Human connection,” she added, staring at the phone contraption strapped to his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0105-01-4"
    }
  }, [_vm._v("“Are you married, William Singer?” Clare asked, and Zoe glared at her sister.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0105-01-5"
    }
  }, [_vm._v("“Me?” He pressed his left hand, void of a wedding ring, against his chest. “No, I’m not married.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0105-01-6"
    }
  }, [_vm._v("Zoe wanted to change the subject before Mr. Singer asked about signing up for her services. She intended to discourage short-timers—guys like this who might just want to date someone while they were in Smitten, then vanish into the proverbial sunset alone. She might be desperate to sign people up for the service, but she wasn’t willing to compromise her principles. She wouldn’t willingly allow hearts to be broken by a traveling man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0105-01-7"
    }
  }, [_vm._v("He lifted the ladder again, as anxious to finish the uncomfortable conversation as she was. “You want to show me where to put this before someone else walks into it and the city has a lawsuit on its hands?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0105-01-8"
    }
  }, [_vm._v("“Mr. Singer, you weren’t looking where you were going. I’m not a fan of this Star Trek communicator stuff becoming reality, for that reason. If you’re going to live here in Smitten, you should know we prefer proper communication. Face-to-face.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0105-01-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page105"
    }
  }, [_vm._v("He gave a lopsided grin. “I’m grateful you’ve decided to share that with me.” He lifted the ladder a few inches ")]), _c('a', {
    attrs: {
      "id": "page106"
    }
  }, [_vm._v("higher. “Where did you want me to put this?” he asked again.")])]), _c('a', {
    attrs: {
      "id": "page106"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0106-03-3"
    }
  }, [_vm._v("“I’m Clare Thomas,” her sister said. “We weren’t formally introduced.” She scowled at Zoe as if to remind her she was supposed to be a matchmaker. “Follow that alley to the back of the store. That’s where Zoe keeps the ladder.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0106-03-4"
    }
  }, [_vm._v("“Pleasure to meet you, Clare,” he said, setting the ladder down again to shake her hand. “This country air produces very pretty women.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0106-03-5"
    }
  }, [_vm._v("Clare rolled her eyes, and Zoe veiled a smile with her hand. “You don’t have to waste your city talk on us Smitten girls. We appreciate the effort, though, and as long as you don’t cite me, that’s compliment enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0106-03-6"
    }
  }, [_vm._v("“Let me ask you something.” William set the ladder down. “Does this personal communication in Smitten get any easier on a guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0106-03-8"
    }
  }, [_vm._v("“You’ll have to excuse my sister. She’s heavily invested in Cupid’s Arrow"), _c('i', [_vm._v(",")]), _vm._v(" and change is not her strong suit anyway. You represent change.” Clare narrowed her eyes just like their mother did, and Zoe thought maybe it wouldn’t hurt her to be less forthright—as her mother always told her. She could still think her truth without saying it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0106-03-9"
    }
  }, [_vm._v("Political insincerity may have worked where William Singer came from, but he’d have to sharpen his skills with authenticity if he meant to stay in Smitten. Of course, he wouldn’t stay in Smitten. He had short-timer written all over him, so she tried not to muster any sympathy for the way his strong jaw set against the slightly pitiful scrape alongside his eye. Nor would she notice how darling it made him look, even if her heart did soften at the sight of it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b562fe66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter17.vue
// module id = 69
// module chunks = 0